__turbopack_context__.v({
  "icon": "AdobeToolIcon-module__QNOLdW__icon",
});
